var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgNoticias(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "89px",
    viewBox: "0 0 92 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_noticias") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-3255.000000, -438.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 5.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_noticias",
    transform: "translate(3258.000000, 441.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,8.92497444 C86,3.59023821 81.7859999,-0.366357697 76.6689997,0.0782036438 L76.411002,0.0782036438 C67.3810024,0.878414077 53.6639991,5.63522105 46.0099992,10.614308 L45.2789989,11.103324 C44.0319989,11.9035344 41.9680011,11.9035344 40.7210011,11.103324 L39.6460011,10.4364837 C31.9920013,5.50185278 18.3179989,0.789501829 9.28799934,0.0337475527 C4.1709991,-0.410813788 0,3.59023715 0,8.88051729 L0,62.5835261 C0,66.8513149 3.35400013,70.8523649 7.48200004,71.3858385 L8.7290009,71.5636671 C18.0600012,72.852895 32.4650013,77.7430723 40.7210011,82.4109661 L40.893001,82.4998719 C42.054001,83.1667139 43.9030012,83.1667139 45.0210011,82.4998719 C53.277001,77.787522 67.725001,72.852895 77.0990013,71.5636671 L78.518001,71.3858385 C82.6460009,70.8523649 86,66.8513149 86,62.5835261 L86,8.92497444 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: 13.8773258,
    x2: 43,
    y2: 79.4036416,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.725,
    y1: 41.4562731,
    x2: 58.05,
    y2: 41.4562731,
    id: "Vector",
    transform: "translate(62.887500, 43.640484) scale(-1, 1) translate(-62.887500, -43.640484) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.725,
    y1: 41.4562731,
    x2: 15.05,
    y2: 41.4562731,
    id: "Vector-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.95,
    y1: 28.35101,
    x2: 58.05,
    y2: 28.35101,
    id: "Vector",
    transform: "translate(64.500000, 30.535220) scale(-1, 1) translate(-64.500000, -30.535220) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.95,
    y1: 28.35101,
    x2: 15.05,
    y2: 28.35101,
    id: "Vector-Copy-9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgNoticias);
export default __webpack_public_path__ + "static/media/svg_noticias.255520818cd61f23f6d61828bce6efe0.svg";
export { ForwardRef as ReactComponent };